import { tv } from '@/common/theme/tv.config';

export const styles = {
  step: tv({
    base: 'h-xs w-xs rounded-full bg-neutral40',
    variants: {
      active: {
        true: 'w-[2rem] rounded-xs bg-accentSecondary40',
      },
    },
  }),
};
